import React, { useState, Fragment } from "react";
import "../style.scss";
const ListToggle = () => {
    const [showList1, setShowList1] = useState("");
    const [showList2, setShowList2] = useState("");
    const [showList3, setShowList3] = useState("");
    const [showList4, setShowList4] = useState("");
    const [showList5, setShowList5] = useState("");
    const [showList6, setShowList6] = useState("");
    const [showList7, setShowList7] = useState("");
    const [showList8, setShowList8] = useState("");
    const toggleList = (listNumber) => {
        if (listNumber === 1) {
            setShowList1(!showList1);
            setShowList2(false);
            setShowList3(false);
            setShowList4(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 2) {
            setShowList2(!showList2);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 3) {
            setShowList3(!showList3);
            setShowList2(false);
            setShowList1(false);
            setShowList4(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 4) {
            setShowList4(!showList4);
            setShowList1(false);
            setShowList3(false);
            setShowList2(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 5) {
            setShowList5(!showList5);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 6) {
            setShowList6(!showList6);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList7(false);
            setShowList8(false);
            setShowList5(false);
        } else if (listNumber === 7) {
            setShowList7(!showList7);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList5(false);
            setShowList6(false);
            setShowList8(false);
        } else if (listNumber === 8) {
            setShowList8(!showList8);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList5(false);
            setShowList7(false);
            setShowList6(false);
        }
    };
    return (
        <Fragment>
            {/* <div className="botam-navbar">
        <p style="margin-left: 15px; color: #fff">To avail the weekly free training offer <br />Sign up Now.</p>
        <a href="#corseform" className="active">To know course fee.</a>
        <a href="#corseform" className="active">Know More</a>
      </div> */}

            <div id="main-wrapper">
                <div className="site-wrapper-reveal">
                    <div
                        className="about-banner-wrap vision-space bg-img responsive_banner_courses"

                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 section-space--pt_100">
                                    <h1 className="mobile-page-heading">Cyber Security
                                    </h1>
                                    <p className="mobile-page-paragraph">
                                        It is the practice of defending computers and servers, mobile devices, etc from malicious attacks.


                                    </p>
                                </div>
                                <div className="col-lg-2"></div>
                                <div className="col-lg-4">
                                    <div
                                        className="form-container mx-auto mx-xl-0 ml-xl-auto border"
                                        id="corseform"
                                        style={{
                                            marginTop: "20px",
                                            backgroundColor: "white",
                                            alignItems: "center",
                                            marginLeft: "100px",
                                        }}
                                    >
                                        <div id="signup-form">
                                            {/* <p style={{ color: "black" }}>Your Enquiry Successfully Submit</p> */}
                                            <form
                                                id="basic-form"
                                                name="yoursite_wp_mail_from_name"
                                                method="post"
                                            />
                                            <input type="hidden" name="courseId" value="753" />
                                            <input type="hidden" name="category" value="16" />
                                            <div
                                                className="form-group"

                                            >
                                                <label>
                                                    Name:
                                                    <input
                                                        type="text"
                                                        id="fname"
                                                        name="fname"
                                                        className="form-control"
                                                        placeholder="Enter Your Name"
                                                       
                                                        required=""
                                                    />
                                                </label>
                                            </div>
                                            <div className="form-group" >
                                                <label>Email:</label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter Your Email Address"
                                                   
                                                    required=""
                                                />
                                            </div>
                                            <div className="form-group" >
                                                <label>Mobile:</label>
                                                <input
                                                    type="number"
                                                    id="phone"
                                                    name="phone"
                                                    className="form-control"
                                                    placeholder="Enter Your mobile number"
                                                   
                                                    required=""
                                                />
                                            </div>
                                            <div
                                                className="form-group mb-0"

                                            >
                                                <div className="form-row">
                                                    <div className="form-group col-6">
                                                        <label className="control-label">State</label>
                                                        <select
                                                            id="states"
                                                            name="states"
                                                            className="form-control"
                                                            required=""
                                                        >
                                                            <option value="">SELECT STATE</option>
                                                            <option value="2">Andhra Pradesh</option>
                                                            <option value="5">Bihar</option>
                                                            <option value="12">Gujarat</option>
                                                            <option value="13">Haryana</option>
                                                            <option value="14">Himachal Pradesh</option>
                                                            <option value="16">Jharkhand</option>
                                                            <option value="17">Karnataka</option>
                                                                                          <option value="17">Kerala</option>

                                                            <option value="21">Maharashtra</option>
                                                            <option value="28">Punjab</option>
                                                            <option value="29">Rajasthan</option>
                                                            <option value="31">Tamil Nadu</option>
                                                            <option value="32">Telangana</option>
                                                            <option value="35">Uttar Pradesh</option>
                                                        </select>
                                                    </div>
                                                    {/* <div className="form-group col-6 city">
                                                        <label className="control-label">Center</label>
                                                        <select
                                                            name="city"
                                                            id="city"
                                                            className="form-control center"
                                                            required=""
                                                        >
                                                            <option value="">SELECT CENTRE</option>
                                                        </select>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div
                                                className="form-group mb-0"
                                                style={{ marginLeft: "130px", paddingBottom: "30px" }}
                                            >
                                                <button
                                                    type="submit"
                                                    id="btn"
                                                    className="btn btn-primary contest_register_now"
                                                    name="register_users"
                                                >
                                                    Apply Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Cyber Security
                    </li>
                </ol>
            </nav>

            <div className="vision-overview  " style={{ marginTop: "-180px" }}>
                <div className="container">
                    <div className="section-title-wrap text-center">
                        <br />
                        <br />
                        <h3 className="heading">
                            <span
                                className="text-color-primary"
                                style={{ fontSize: "25px", color: "#ffc107" }}
                            >
                                {" "}
                                Training Highlights
                            </span>
                        </h3>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">Instructor Led Training</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">Weekly Doubt clearing Session</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">Lifetime Assistance for Revision</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">
                                        Lifetime Login Access to Student Dashboard
                                    </h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">World-Wide Valid Certification</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">
                                        Study Material, Assignments and Projects
                                    </h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br /> <br />
                    <div
                        className="section-title-wrap text-center"
                        style={{ marginTop: "-140px" }}
                    >
                        <h3 className="heading">
                            <span
                                className="text-color-primary"
                                style={{ fontSize: "30px", color: "#ffc107" }}
                            >
                                {" "}
                                Course Highlights
                            </span>
                        </h3>
                    </div>
                    <div className="row">
                        <div className="d-flex flex-row flex-lg-column align-items-lg-center mx-auto">
                            {/* <div className="dashed-border">
                                <img
                                    className="d-block d-lg-none"
                                    src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_mobile.svg"
                                />
                                <img
                                    className="d-none d-lg-block"
                                    src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_desktop.svg"
                                    width={1000}
                                />
                            </div> */}
                            <div className="d-flex flex-column  align-items-start flex-lg-row justify-content-lg-center">
                                <div className="item-container  justify-content-between d-flex flex-lg-column align-items-center ">
                                    <div
                                        className="number-container"
                                       
                                    >
                                        <div className="number-box">1</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">Ethical hacking

                                        </p>
                                    </div>
                                </div>
                                <div className="item-container d-flex flex-lg-column align-items-center">
                                    <div className="number-container">
                                        <div className="number-box">2</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">
                                            Footprinting through Websites

                                        </p>
                                    </div>
                                </div>
                                <div className="item-container d-flex flex-lg-column align-items-center">
                                    <div className="number-container">
                                        <div className="number-box">3</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">Introduction to Network scanning

                                        </p>
                                    </div>
                                </div>
                                <div className="item-container d-flex flex-lg-column align-items-center">
                                    <div className="number-container">
                                        <div className="number-box">4</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">Network enumeration tools

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "-120px" }}>
                        <div className="col-lg-12">
                            <br />
                            <br />
                            {/* <!-- <h3 className="heading" style="font-size: 21px;">Course Overview</h3> --> */}
                            <h3 className="heading">
                                <span
                                    className="text-color-primary"
                                    style={{ fontSize: "30px", color: "#ffc107" }}
                                >
                                    {" "}
                                    Course Overview
                                </span>
                            </h3>
                            <br />
                            <br />
                            <div>
                                <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: 'justify' }}>
                                    Cyber Security is the practice of defending computers, servers, mobile devices, electronic systems, networks, and data from malicious attacks. It’s also known as information technology security or electronic information security.  By joining CAD DESK classroom training for Cyber Security, students get an opportunity to learn from our expert trainers; who gives a great emphasis on delivering the best quality training to each of its learners.

                                    Cyber Security is a completely authorized practice that helps in figuring out the shortcomings and strengthens the security of the system, network, or applications. Learning Cyber Security helps in enhancing knowledge about programming, network skills, and databases. CAD DESK delivers the best IT, CAD, CAM, and CAE software training in India. While doing the software training, students get an option to do an Internship and develop their skills by working on projects.

                                    While learning from CAD DESK coaching classes, it also provides 100% Placement assistance to all of its students. During the classes, students get many other facilities including study materials, e-books, various tutorials & projects related to Cyber Security; which works as an additional benefit to them. Further, students get a provision to transfer to any of our franchise centers in India; even if they have enrolled in CAD DESK Jaipur or at any other CAD DESK center. At the end of course completion, CAD DESK students get a certificate that is completely verified and provides great recognition to the students in the industry.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                }}
            >
                <div style={{ flex: 1 }}>
                    <h3 className="heading_course_content">
                        <span
                            className="text-color-primary  responsive_course_content"

                        >
                            {" "}
                            Course Contents
                        </span>
                    </h3>

                    <div classNameName="row">
                        {" "}

                        <div className="responsive_courese_image_container_mobile_view">
                            <img
                                src="img/Cyber-Security.webp"
                                alt="Course Image"
                                className="responsive_course_image_mobile_view"
                            />
                        </div>

                        <div
                            className="responsive_introduction_container"
                        >
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(1)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList1 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Introduction
                            </button>
                            {showList1 && (
                                <ul>
                                    <li>What is Hacking?
                                    </li>
                                    <li>Ethical hacker
                                    </li>
                                    <li>Information Security Laws and Standards
                                    </li>
                                    <li>Information Security
                                    </li>
                                    <li>Incident Management
                                    </li>
                                    <li>Data breaches and malware trends

                                    </li>
                                    <li>Threat modelling

                                    </li>
                                    <li>EISA, Vulnerability Assessment, VA research, info warfare

                                    </li>

                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(2)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList2 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                FootPrinting
                            </button>
                            {showList2 && (
                                <ul>
                                    <li>Footprint through Search engines
                                    </li>
                                    <li>Google hacking-dorking
                                    </li>
                                    <li>Web crawler / Spider
                                    </li>
                                    <li>Footprinting through Websites
                                    </li>


                                    <li>Whois lookup

                                    </li>
                                    <li>Whois lookup

                                    </li>
                                    <li>Traceroute, Looking glass server, BGP Tools

                                    </li>
                                    <li>NSLookup

                                    </li>
                                    <li>SNMP – Simple Network Management Protocol

                                    </li>
                                    <li>Footprinting through email tracking

                                    </li>
                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(3)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList3 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Network Scanning              </button>
                            {showList3 && (
                                <ul>
                                    <li>Introduction to Network scanning
                                    </li>

                                    <li>Network port scanning
                                    </li>
                                    <li>Network scanning tools
                                    </li>
                                    <li>Nmap – Network mapper – scanner
                                    </li>
                                    <li>Network monitoring tools – Open source
                                    </li>
                                    <li>Network monitoring tools – Commercial
                                    </li>

                                    <li>Ping – Ping sweep

                                    </li>
                                    <li>HPing and FPing demo on Kali Linux

                                    </li>
                                    <li>HPing and FPing

                                    </li>
                                    <li>Proxy Servers 1

                                    </li>
                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(4)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList4 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Network Enumeration
                            </button>
                            {showList4 && (
                                <ul>
                                    <li>Network Enumeration introduction
                                    </li>
                                    <li>Network enumeration tools
                                    </li>
                                    <li>Scanning and Enumeration Countermeasures
                                    </li>
                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(5)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList5 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                System Hacking
                            </button>
                            {showList5 && (
                                <ul>
                                    <li>Hacking Methodology
                                    </li>
                                    <li>Password cracking
                                    </li>
                                    <li>Brute-force attack
                                    </li>
                                    <li>Ophcrack – Windows password cracker
                                    </li>
                                    <li>Custom Word List generator
                                    </li>
                                    <li>Crunch wordlist generator
                                    </li>

                                    <li>Pwdump – Password Dumper and Hash Suite

                                    </li>
                                    <li>Hashcat – advanced password recovery tool

                                    </li>


                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(6)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList6 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Malware Trojans
                            </button>
                            {showList6 && (
                                <ul>
                                    <li> Trojan horse (Trojan) introduction
                                    </li>
                                    <li>Beast trojan – Remote Administration Tool (RAT)
                                    </li>
                                    <li>Beast Trojan demo – Educational purpose ONLY
                                    </li>
                                    <li>Process explorer
                                    </li>
                                    <li>Malware countermeasures
                                    </li>

                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(7)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList7 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Malware- virus and  worms
                            </button>
                            {showList7 && (
                                <ul>
                                    <li> Virus introduction
                                    </li>
                                    <li>How virus works
                                    </li>
                                    <li>Creating Projection Views</li>
                                    <li>Virus removal
                                    </li>
                                    <li>Virus maker tools

                                    </li>

                                </ul>
                            )}
                        </div>





                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(7)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList7 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Packet Sniffers

                            </button>
                            {showList7 && (
                                <ul>
                                    <li> Packet Sniffers

                                    </li>
                                    <li>Wireshark

                                    </li>
                                    <li>Countermeasures-Sniffing
                                    </li>
                                    <li>Xplico

                                    </li>


                                </ul>
                            )}
                        </div>




                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(7)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList7 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Social Engineering

                            </button>
                            {showList7 && (
                                <ul>
                                    <li> Social engineering introduction


                                    </li>
                                    <li>Social engineering techniques


                                    </li>
                                    <li>Social engineering countermeasures

                                    </li>


                                </ul>
                            )}
                        </div>



                           <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(7)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList7 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                              DoS/DDoS attacks 

                            </button>
                            {showList7 && (
                                <ul>
                                    <li> DoS-DDoS attacks Introduction



                                    </li>
                                    <li>DoS-DDoS attack Types


                                    </li>
                                    <li>DoS-DDoS attack techniques and tools


                                    </li>


                                </ul>
                            )}
                        </div>
                    </div>
                </div>

                <div className="responsive_courese_image_container">
                    <img
                        src="img/Cyber-Security.webp"
                        alt="Course Image"
                        className="responsive_course_image"
                    />
                </div>
            </div>

            <div className="contact-us-section-wrappaer ">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7 col-lg-7">
                            <div className="conact-us-wrap-one">
                                <br />
                                <br />
                                <h5 className="heading mb-20">
                                    How will you get your certificate?
                                </h5>
                                <div className="center_details">
                                    {/* <!--   <h5 className="heading mb-20">CERTIFICATE FAQ</h5> --> */}
                                    <p>
                                        Upon successful completion of the program, each intern
                                        receives a prestigious Digital Marketing Internship
                                        Certificate. This credential not only recognizes their
                                        achievements but also enhances their employability.
                                    </p>
                                    <p style={{ textAlign: "justify" }}>
                                        CAD DESK  Kaniyapuram is a pioneer in Mechanical/Civil
                                        training and most of the industries give great recognition
                                        to its certificate throughout India and abroad. CAD DESK
                                         Kaniyapuram Certificates are ISO verified which makes it
                                        highly reputed comparing to the other local brands and helps
                                        the student get prioritize while going for job opportunities
                                        in the industry. CAD DESK  Kaniyapuram Software Training is
                                        conducted by highly knowledgeable trainers which help
                                        students to enhance their skill set by putting great
                                        emphasizes on project-based learning.
                                    </p>
                                    {/* <!-- <a className="btn btn-primary">Get Certificate</a> --> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-lg-5">
                            <div className="contact-form-wrap">
                                {/* <!-- <h5 className="heading mb-20">How will you get your certificate?</h5> --> */}
                                <img
                                    src="img/Certificate.webp"
                                    style={{
                                        width: " 100%",
                                        marginTop: "100px",
                                        height: "370px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
        </Fragment>
    );
};

export default ListToggle;
